import React from 'react';
import { Container } from 'AppReact';

const ContainerComponent = (definition) => {
  const { initialProps, controller } = definition;
  const Cont = Container(definition);
  const comp = ({ eventManager, eventName, bindings, __overrides__ }) => {
    const init = (_state, outlet, internalStateSetter) => {
      const initialState = initialProps(bindings);
      controller.init?.(initialState, outlet, internalStateSetter);
      internalStateSetter(initialState);
    };
    const newController = { ...controller, init };
    newController.refreshOn = () => Object.values(bindings);

    return (
      <Cont
        controller={newController}
        __overrides__={__overrides__}
        stateManager={(values) => eventManager(eventName, { ...bindings, ...values })}
      />
    );
  };
  comp._appReactType = 'containerComponent';
  return comp;
};

export default ContainerComponent;
